import en from 'translations/en.json'

export type TranslationsKeys = keyof typeof en

export const createTranslationKey = <T extends string, U extends string>(field: T, prefix: U) =>
  `${prefix}${field}` as `${U}${T}` extends TranslationsKeys ? TranslationsKeys : string
